import { render, staticRenderFns } from "./MyPage.vue?vue&type=template&id=4ac6ea60&scoped=true&"
import script from "./MyPage.vue?vue&type=script&lang=js&"
export * from "./MyPage.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/renew2_mypage.css?vue&type=style&index=0&lang=css&"
import style1 from "./MyPage.vue?vue&type=style&index=1&id=4ac6ea60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac6ea60",
  null
  
)

export default component.exports